import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { isUndefinedNullOrEmpty } from '../../../js/utils';
import { reliablyHandleAsyncFormSubmit } from '../formUtils';
import CreateBackupLocationForm from './BackupLocationForm';
import { addBackupLocation, requestBackupLocationValidation } from  '../../../js/actions/backupLocationActionCreators';

const validationStatus = {
    success: 'success',
    failed: 'failed',
    cancelled: 'cancelled'
};

const validate = (values) => {
    const errors = {};

    if(isUndefinedNullOrEmpty(values.fileShareLocation)) {
        errors.fileShareLocation = 'Specify the file share location';
    } else if(values.fileShareLocation.length > 450) {
        errors.fileShareLocation = 'File share location path cannot have more than 450 characters';
    }

    if(isUndefinedNullOrEmpty(values.associatedSqlServerInstance)) {
        errors.associatedSqlServerInstance = 'Select an SQL Server instance to associate';
    }

    return errors;
};

const BackupLocationForm = CreateBackupLocationForm('BackupLocationAddForm', validate);

const BackupLocationAddForm = React.createClass({
    setValidationSuccedded: null,
    setValidationFailed: null,
    propTypes: {
        onSuccess: PropTypes.func,
        onCancel: PropTypes.func,
        addBackupLocation: PropTypes.func.isRequired,
        startBackupLocationValidation: PropTypes.func.isRequired
    },
    getInitialState: function() {
        return {
            validationOperationIdToTrack: null,
            validationStatus: null
        };
    },
    componentWillReceiveProps: function(nextProps) {
        const { getOperation } = nextProps;
        const { validationOperationIdToTrack } = this.state;

        if(!isUndefinedNullOrEmpty(validationOperationIdToTrack)) {
            const operation = getOperation(validationOperationIdToTrack);
            if(!isUndefinedNullOrEmpty(operation) && !isUndefinedNullOrEmpty(operation.resultDetails)) {
                const { resultDetails } = operation;
                if(resultDetails.isSuccess === true) {
                    this.setValidationSuccedded();
                } else {
                    this.setValidationFailed(resultDetails.errorMessage);
                }

                this.setState({
                    validationOperationIdToTrack: null,
                    validationStatus: resultDetails.isSuccess ? validationStatus.success : validationStatus.failed
                });
            }
        }
    },
    handleSubmit: function(data) {
        const { addBackupLocation, startBackupLocationValidation, onSuccess } = this.props;
        const backupLocationToAdd = {
            temporaryInstanceId: data.associatedSqlServerInstance,
            backupBasePath: data.fileShareLocation
        };

        return reliablyHandleAsyncFormSubmit(() => {
            this.setState({ validationStatus: null });
            return startBackupLocationValidation(backupLocationToAdd).then((operationDetails) => {
                this.setState({ validationOperationIdToTrack: operationDetails.id });
                return new Promise((resolve, reject) => {
                    this.setValidationSuccedded = resolve;
                    this.setValidationFailed = reject;
                });
            }).then(() => addBackupLocation(backupLocationToAdd)).then(addedBackupLocation => {
                if(onSuccess) {
                    onSuccess(addedBackupLocation);
                }
            });
        });
    },
    render: function () {
        const { onCancel } = this.props;
        return <BackupLocationForm actionName="Add" onValid={this.handleSubmit} onCancel={onCancel} />;
    }
});

const mapStateToProps = (state) => ({
    getOperation: (operationId) => state.operations.value.get(operationId)
});

const mapDispatchToProps = (dispatch) => {
    return {
        addBackupLocation: (backupLocation) => {
            return dispatch(addBackupLocation(backupLocation));
        },
        startBackupLocationValidation: (backupLocation) => {
            return dispatch(requestBackupLocationValidation(backupLocation));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(BackupLocationAddForm);



// WEBPACK FOOTER //
// ./src/components/common/BackupLocationSelection/BackupLocationAddForm.jsx